// MST
import { types } from 'mobx-state-tree'

// Helper
import { withHelper_commonLoadingModel } from './common.helper'

// Constant
import { ASSESSMENT_STATUS } from 'constant/shared.constant'

// Types
const { model, maybe, maybeNull, enumeration, string, number } = types

export const withHelper_fileProps = {
  originalFileName: maybeNull(string),
  blobId: maybeNull(string),
}

export const withHelper_fileWithIdProps = {
  id: maybeNull(string),
  ...withHelper_fileProps,
}

export const withHelper_fileUserProps = {
  userOriginalFileName: maybeNull(string),
  userFileBlobId: maybeNull(string),
}

export const withHelper_fileUserWithIdProps = {
  userFileTransactionId: maybeNull(number),
  ...withHelper_fileUserProps,

  // For Front-End Only
  id: maybe(maybeNull(string)),
}

export const withHelper_fileUserWithIdStatusProps = {
  ...withHelper_fileUserWithIdProps,
  status: maybeNull(enumeration('Status', Object.values(ASSESSMENT_STATUS))),
}

export const withHelper_fileUserModel = model('FileUser').props({
  ...withHelper_fileUserProps,
})

export const withHelper_fileModel = model('File').props({
  ...withHelper_fileProps,
})

export const withHelper_fileWithIdModel = model('FileWithId').props({
  ...withHelper_fileWithIdProps,
})

export const withHelper_fileUserWithIdModel = model('FileUserWithId').props({
  ...withHelper_fileUserWithIdProps,

  // For Front-End Only
  loading: withHelper_commonLoadingModel,
})

export const withHelper_fileUserWithIdStatusModel = model('FileUserWithIdStatus').props({
  ...withHelper_fileUserWithIdStatusProps,

  // For Front-End Only
  loading: withHelper_commonLoadingModel,
})
